import { Box, Typography, useTheme } from '@mui/material';
import React, { useMemo } from 'react';

import { IInventoryItem } from '../../../types/inventories';
import { isItemOutOfStock } from '../../../utils/inventories';
import FCDetails from '../../FCDetails/FCDetails';
import { ItemCountWithWarning } from './ItemCountWithWarning';

interface IProps {
  item: IInventoryItem;
  index?: number;
}

export const MskuNestedItem: React.FC<IProps> = ({ item, index }) => {
  const { palette, typography } = useTheme();
  const {
    name,
    image_url,
    count,
    product_sku,
    fulfillment_center_id,
    preorder_allowed: isPreorderAllowed,
    type,
    low_stock_threshold: threshold,
  } = item;

  const isDisabled = useMemo(() => isItemOutOfStock(item), [item]);

  const dataIndex = useMemo(() => (index !== undefined ? { 'data-index': index } : {}), [index]);

  return (
    <Box {...dataIndex} sx={{ display: 'flex', flexDirection: 'row', gap: 2 }}>
      <Box
        sx={{
          width: 72,
          height: 72,
          borderRadius: 0.5,
          border: `1px solid ${palette.action.focus}`,
          backgroundImage: `url("${image_url}")`,
          backgroundSize: 'contain',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center',
          opacity: isDisabled ? 0.5 : 1,
        }}
      />
      <Box sx={{ py: 0.25, display: 'flex', flexDirection: 'column' }}>
        <Box sx={{ mb: 0.8 }}>
          <Typography
            variant="body1"
            sx={{
              fontWeight: typography.fontWeightMedium,
              lineHeight: '19px',
              color: isDisabled ? palette.text.disabled : palette.text.primary,
            }}
          >
            {name}
          </Typography>
        </Box>
        <Box sx={{ mb: 0.5 }}>
          <FCDetails
            fulfillmentCenterId={fulfillment_center_id}
            productSku={product_sku}
            withLabel={true}
            isHorizontal={true}
          />
        </Box>
        <Box sx={{ height: 18, display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 1 }}>
          <ItemCountWithWarning type={type} count={count} isPreorderAllowed={isPreorderAllowed} threshold={threshold} />
        </Box>
      </Box>
    </Box>
  );
};
